import { Box, Typography } from "@mui/material";
import React from "react";
import GitHubIcon from "@mui/icons-material/GitHub";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { Link } from "react-scroll";

const Footer = () => {
  const handleContactClick = () => {
    const recipient = "mlikbk@hotmail.com";

    const mailtoLink = `mailto:${recipient}?`;
    window.location.href = mailtoLink;
  };

  return (
    <Box
      sx={{
        maxWidth: "1100px",
        borderTop: "1px solid #B3565B",
        mx: "auto",
        padding: 3,
        display: "flex",
        justifyContent: "space-around",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          variant="body1"
          sx={{ color: "#ecc8af", fontWeight: "bold", mb: 2 }}
        >
          SIDAN
        </Typography>

        <Link
          to="projects"
          className="link"
          smooth
          style={{ color: "white", margin: "0.5rem 0", cursor: "pointer" }}
        >
          Projekt
        </Link>
        <Link
          to="skills"
          className="link"
          smooth
          style={{ color: "white", margin: "0.5rem 0", cursor: "pointer" }}
        >
          Skills
        </Link>
        <Link
          to="about"
          className="link"
          smooth
          style={{ color: "white", margin: "0.5rem 0", cursor: "pointer" }}
        >
          Om mig
        </Link>

        {/* 

        <Typography
          variant="body2"
          sx={{ color: "white", my: 1, cursor: "pointer" }}
        >
          Home
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "white", my: 1, cursor: "pointer" }}
        >
          Experience
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "white", my: 1, cursor: "pointer" }}
        >
          About
        </Typography> */}
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          variant="body1"
          sx={{ color: "#ecc8af", fontWeight: "bold", mb: 2 }}
        >
          SOCIAL
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
          <a
            href="https://github.com/Kwixie"
            style={{ display: "flex", alignItems: "center" }}
          >
            <GitHubIcon sx={{ mr: 2, color: "white" }} />
            <Typography variant="body2" sx={{ color: "white", my: 1 }}>
              GitHub
            </Typography>
          </a>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
          <a
            href="/"
            style={{ display: "flex", alignItems: "center" }}
            onClick={handleContactClick}
          >
            <EmailIcon sx={{ mr: 2, color: "white" }} />
            <Typography variant="body2" sx={{ color: "white", my: 1 }}>
              Email
            </Typography>
          </a>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
          <a
            href="https://www.linkedin.com/in/emelie-k%C3%B6hler-76773b171/"
            style={{ display: "flex", alignItems: "center" }}
          >
            <LinkedInIcon sx={{ mr: 2, color: "white" }} />
            <Typography variant="body2" sx={{ color: "white", my: 1 }}>
              LinkedIn
            </Typography>
          </a>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
